






import { Component, Vue } from 'vue-property-decorator';

// 声明组件*****************
@Component({
  components: {

  }
})
export default class Message extends Vue {
  // 属性*****************
  // private type: string = 'loading';
  private show: boolean = true;
  private timer: any = 3000;
  private value: string = '';
  mounted () {
      let timer = setTimeout(()=>{
          this.show = false;
      },this.timer)
  }

  // 方法*****************

}
